'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncGeneratorDelegate = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

var dir = require('./dir.js');

var index = require('./file/index.js');

var errCode = require('err-code');

var rabin = require('../chunker/rabin.js');

var fixedSize = require('../chunker/fixed-size.js');

var validateChunks = require('./validate-chunks.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

function isIterable(thing) {
  return Symbol.iterator in thing;
}

function isAsyncIterable(thing) {
  return Symbol.asyncIterator in thing;
}

function contentAsAsyncIterable(content) {
  try {
    if (content instanceof Uint8Array) {
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return content;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    } else if (isIterable(content)) {
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.delegateYield(_asyncGeneratorDelegate(_asyncIterator(content), _awaitAsyncGenerator), "t0", 1);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    } else if (isAsyncIterable(content)) {
      return content;
    }
  } catch (_unused) {
    throw errCode__default['default'](new Error('Content was invalid'), 'ERR_INVALID_CONTENT');
  }

  throw errCode__default['default'](new Error('Content was invalid'), 'ERR_INVALID_CONTENT');
}

function dagBuilder(_x, _x2, _x3) {
  return _dagBuilder.apply(this, arguments);
}

function _dagBuilder() {
  _dagBuilder = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(source, blockstore, options) {
    var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, entry;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context5.prev = 2;
            _iterator = _asyncIterator(source);

          case 4:
            _context5.next = 6;
            return _awaitAsyncGenerator(_iterator.next());

          case 6:
            if (!(_iteratorAbruptCompletion = !(_step = _context5.sent).done)) {
              _context5.next = 21;
              break;
            }

            entry = _step.value;

            if (entry.path) {
              if (entry.path.substring(0, 2) === './') {
                options.wrapWithDirectory = true;
              }

              entry.path = entry.path.split('/').filter(function (path) {
                return path && path !== '.';
              }).join('/');
            }

            if (!entry.content) {
              _context5.next = 13;
              break;
            }

            return _context5.delegateYield( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
              var chunker, chunkValidator, file;
              return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      chunker = void 0;

                      if (typeof options.chunker === 'function') {
                        chunker = options.chunker;
                      } else if (options.chunker === 'rabin') {
                        chunker = rabin;
                      } else {
                        chunker = fixedSize;
                      }

                      chunkValidator = void 0;

                      if (typeof options.chunkValidator === 'function') {
                        chunkValidator = options.chunkValidator;
                      } else {
                        chunkValidator = validateChunks;
                      }

                      file = {
                        path: entry.path,
                        mtime: entry.mtime,
                        mode: entry.mode,
                        content: chunker(chunkValidator(contentAsAsyncIterable(entry.content), options), options)
                      };
                      _context3.next = 7;
                      return function () {
                        return index(file, blockstore, options);
                      };

                    case 7:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3);
            })(), "t0", 11);

          case 11:
            _context5.next = 18;
            break;

          case 13:
            if (!entry.path) {
              _context5.next = 17;
              break;
            }

            return _context5.delegateYield( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
              var dir$1;
              return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      dir$1 = {
                        path: entry.path,
                        mtime: entry.mtime,
                        mode: entry.mode
                      };
                      _context4.next = 3;
                      return function () {
                        return dir(dir$1, blockstore, options);
                      };

                    case 3:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _callee4);
            })(), "t1", 15);

          case 15:
            _context5.next = 18;
            break;

          case 17:
            throw new Error('Import candidate must have content or path or both');

          case 18:
            _iteratorAbruptCompletion = false;
            _context5.next = 4;
            break;

          case 21:
            _context5.next = 27;
            break;

          case 23:
            _context5.prev = 23;
            _context5.t2 = _context5["catch"](2);
            _didIteratorError = true;
            _iteratorError = _context5.t2;

          case 27:
            _context5.prev = 27;
            _context5.prev = 28;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context5.next = 32;
              break;
            }

            _context5.next = 32;
            return _awaitAsyncGenerator(_iterator.return());

          case 32:
            _context5.prev = 32;

            if (!_didIteratorError) {
              _context5.next = 35;
              break;
            }

            throw _iteratorError;

          case 35:
            return _context5.finish(32);

          case 36:
            return _context5.finish(27);

          case 37:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[2, 23, 27, 37], [28,, 32, 36]]);
  }));
  return _dagBuilder.apply(this, arguments);
}

module.exports = dagBuilder;